import { render, staticRenderFns } from "./ServerNav.vue?vue&type=template&id=bda6f166&"
import script from "./ServerNav.vue?vue&type=script&lang=js&"
export * from "./ServerNav.vue?vue&type=script&lang=js&"
import style0 from "./ServerNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports